import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import styles from '../css/modules/PricingOptions.module.css';
import { useCart } from '../components/CartContext';
import CartModal from '../components/CartModal';

const PricingOptions = () => {
  const { addToCart } = useCart();
  const [isModalOpen, setModalOpen] = useState(false);

  const options = [1, 2, 3].map(i => {
    const days = parseInt(process.env[`REACT_APP_PLAN${i}_DAYS`], 10) || 0;
    const price = parseFloat(process.env[`REACT_APP_PLAN${i}_PRICE`]) || 0;
    const descRaw = process.env[`REACT_APP_PLAN${i}_DESC`] || '';
    const desc = descRaw.replace(/^['"“”]+|['"“”]+$/g, '');
    return {
      id: i,
      name: `${days} dni`,
      duration: days.toString(),
      price: `${price} zł`,
      description: desc
    };
  });

  const handlePurchase = option => {
    addToCart(option);
    setModalOpen(true);
  };

  return (
    <>
      <Helmet>
        <title>{process.env.REACT_APP_PRICING_META_TITLE || 'Cennik nauki – CyberDriver'}</title>
        <meta
          name="description"
          content={
            process.env.REACT_APP_PRICING_META_DESCRIPTION ||
            'Sprawdź nasze pakiety do nauki do egzaminu ósmoklasisty. Wybierz plan dopasowany do Twoich potrzeb!'
          }
        />
      </Helmet>

      <div className={styles.container}>
        <video
          autoPlay muted loop playsInline webkitplaysinline="true"
          className={styles.backgroundVideo}
          poster="/backgrounds/why-promo-001.webp"
        >
          <source src="/backgrounds/why_cyberdriver_video_small.mp4" type="video/mp4" />
          Twoja przeglądarka nie obsługuje odtwarzania wideo.
        </video>
        <div className={styles.overlay}></div>

        <div className={styles.content}>
          <h1>{process.env.REACT_APP_PRICING_TITLE || 'Wybierz najlepszy plan dla siebie'}</h1>
          <p className={styles.intro}>
            {process.env.REACT_APP_PRICING_SUBTITLE || 'Znajdź idealny pakiet na naukę do egzaminu!'}
          </p>
          <div className={styles.pricingGrid}>
            {options.map(option => (
              <div key={option.id} className={styles.pricingCard}>
                {option.id === 2 && <div className={styles.badge}>BEST SELLER</div>}
                <h2>{option.name}</h2>
                {option.id === 2 && (
                  <p className={styles.discountPrice}>
                    {process.env.REACT_APP_PLAN2_DISCOUNT_PRICE || '79 zł'}
                  </p>
                )}
                <p className={styles.price}>{option.price}</p>
                <p className={styles.description}>{option.description}</p>
                <button
                  className={styles.buyButton}
                  onClick={() => handlePurchase(option)}
                >
                  Dodaj do koszyka
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
      <CartModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
};

export default PricingOptions;
